import React from "react";
import { Link } from "react-router-dom";
import { PageHero, SectionWrapper } from "../components/Section";

const SECTIONS = [
  {
    title: "Primary",
    items: [
      ["/", "Home"],
      ["/solutions", "Solutions"],
      ["/product-portfolio", "Product Portfolio"],
      ["/technology", "Technology"],
      ["/implementation", "Implementation"],
      ["/markets", "Markets"],
      ["/about", "About"],
      ["/contact", "Contact"],
    ],
  },
  {
    title: "Solutions detail",
    items: [
      ["/solutions/structured-institutions", "For Universities, Hospitals, Chambers, Unions & Multi-Department Institutions"],
      ["/solutions/municipality", "For Municipalities & Local Public Administrations"],
      ["/solutions/industrial-zone", "For Industrial Zones, Utilities & Service Operators"],
      ["/solutions/electronic-document", "For Document-Intensive & Regulated Service Environments"],
      ["/solutions/finance-revenue", "For Finance, Revenue & Administrative Operations"],
      ["/solutions/field-infrastructure", "For Field, Facility, Laboratory & Technical Operations"],
      ["/solutions/portals-integrations", "For Portals, Integrations & Executive Visibility"],
    ],
  },
  {
    title: "Product portfolio",
    items: [
      ["/product-portfolio#family-a", "A. Institutional Management Platforms"],
      ["/product-portfolio#family-b", "B. Municipality & Public Service Systems"],
      ["/product-portfolio#family-c", "C. Industrial Zone & Utility Management"],
      ["/product-portfolio#family-d", "D. Document, Records & Digital Transformation"],
      ["/product-portfolio#family-e", "E. Finance, Revenue & Procurement"],
      ["/product-portfolio#family-f", "F. Field, Infrastructure & Spatial Operations"],
      ["/product-portfolio#family-g", "G. Portals, Integrations & External Systems"],
    ],
  },
  {
    title: "Legal",
    items: [
      ["/legal-center", "Legal Center"],
      ["/privacy", "Privacy Policy"],
      ["/cookie-policy", "Cookie Policy"],
      ["__cookie-settings__", "Cookie Settings"],
      ["/terms", "Terms of Use"],
      ["/disclaimer", "Disclaimer"],
      ["/company-information", "Company Information / Legal Notice"],
      ["/security", "Security"],
      ["/accessibility", "Accessibility"],
    ],
  },
];

const Sitemap = () => (
  <main data-testid="page-sitemap">
    <PageHero
      overline="Sitemap"
      title="A clear map of the Allinstra website."
      lead="All public sections, deep links and legal references in one place."
    />
    <SectionWrapper id="sitemap-grid">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {SECTIONS.map((s) => (
          <div key={s.title} className="bg-white border border-ink-200 p-6 card-hover">
            <div className="tag-overline">{s.title}</div>
            <ul className="mt-4 space-y-2.5">
              {s.items.map(([to, label]) => {
                if (to === "__cookie-settings__") {
                  return (
                    <li key="cookie-settings">
                      <button
                        type="button"
                        onClick={() =>
                          window.dispatchEvent(
                            new CustomEvent("allinstra:open-cookie-settings")
                          )
                        }
                        data-testid="sitemap-cookie-settings"
                        className="text-sm text-ink-800 hover:text-cyan-700 transition-colors text-left"
                      >
                        {label}
                      </button>
                    </li>
                  );
                }
                return (
                  <li key={to}>
                    <Link
                      to={to}
                      data-testid={`sitemap-link-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="text-sm text-ink-800 hover:text-cyan-700 transition-colors"
                    >
                      {label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
    </SectionWrapper>
  </main>
);

export default Sitemap;
